// import { capitalCase } from 'change-case'
// import Copy from 'clipboard-copy'
import fnDebounce from 'debounce'
import parsePhoneNumber from 'libphonenumber-js'
import { nanoid } from 'nanoid'
import { watch } from 'vue'
import { useRoute } from 'vue-router'
import DateFormatter from './fmt/date'
import NumberFormatter from './fmt/number'

export const debounce = fnDebounce

export const fmt = {
  ...DateFormatter,
  ...NumberFormatter,
  phone: (value: string) => {
    const phoneNumber = parsePhoneNumber(value, 'ID')
    return phoneNumber?.formatNational() ?? 'invalid phone'
  },
}

export const randomId = nanoid

/**
 * Watch the route full path, and trigger callback when query / params change
 * but don't trigger when route name change (move away to other page).
 * Optional watchSource to watch just specific part of the route (not fullPath).
 */
export const whenRouteChange = (callback: () => void, watchSource?: () => unknown) => {
  const route = useRoute()
  const routeName = route.name // cache route name
  watch(
    watchSource ?? (() => route.fullPath),
    () => {
      if (route.name === routeName) {
        callback()
      }
    },
    { immediate: true },
  )
}

/**
 * Filter array by javascript (example usage: search in region page list)
 */
// export const jsSearch = <T>(needle: string, haystack: T[], callback: (item: T) => string) => {
//   const sanitize = (str: string) => str.toLowerCase().replace(/\s+/g, '')
//   const sanitizedNeedle = sanitize(needle)
//   return haystack.filter((item: T) => {
//     const sanitizedName = sanitize(callback(item))
//     return sanitizedName.includes(sanitizedNeedle)
//   })
// }

// export const copy = async (text: string) => {
//   const toast = useToastStore()
//   try {
//     await Copy(text)
//     toast.add('Teks telah disalin')
//   } catch (error) {
//     toast.add('Gagal menyalin teks')
//     console.log(error)
//   }
// }

// export const useCheckboxIndeterminate = <T>(selected: Ref<T[]>, haystack: ComputedRef<T[]>) => {
//   const someSelected = computed(() => {
//     return selected.value.length > 0 && selected.value.length < haystack.value.length
//   })
//   const allSelected = computed({
//     get: () => selected.value.length === haystack.value.length && haystack.value.length > 0,
//     set: (value: boolean) => {
//       if (value) {
//         selected.value = haystack.value
//       } else {
//         selected.value = []
//       }
//     },
//   })

//   return {
//     someSelected,
//     allSelected,
//   }
// }
